"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BusSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<rect x="1" y="12" width="2" height="4" rx="1"/><rect x="29" y="12" width="2" height="4" rx="1"/><path d="M24 2H8a4 4 0 00-4 4V24A1.9 1.9 0 005.8 26h20.4a1.9 1.9 0 001.8-1.9V6A4 4 0 0024 2zM10 22a2 2 0 112-2 2 2 0 01-2 2zm12 0a2 2 0 112-2 2 2 0 01-2 2zm4-8a2.1 2.1 0 01-2.2 2H8.2A2.1 2.1 0 016 14V8a2.1 2.1 0 012.2-2h15.6A2.1 2.1 0 0126 8zM19 26v2a2 2 0 002 2h2a2 2 0 002-2v-2zM7 26v2a2 2 0 002 2h2a2 2 0 002-2v-2z"/>';
var BusSVG = function BusSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BusSVG = BusSVG;
BusSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BusSVG);
exports.default = _default;